import React, {Component, createRef} from 'react';
import {gsap} from 'gsap';
import './Scene7.css';
import WaveContainer from '../WaveContainer';
import {MenuIcons} from "../menu/MenuIcons";
import {getSpan} from "../../Utilities/utils";

const scene7 = createRef();

class Scene7 extends Component<> {
    componentDidMount() {
        gsap.timeline({
            scrollTrigger: {
                trigger: scene7.current,
                start: 'top 40%',
                end: 'top 20%',
                scrub: true,
                toggleActions: 'play complete restart reverse',
            }
        }).to('#s6gcH',{
            attr:{x1: -25, x2: 0},
            duration: 1,
        }).to('#s6gcV',{
            attr:{y1: -45, y2: -30},
            duration: 1,
        }, '0');

        gsap.timeline({
            scrollTrigger: {
                trigger: scene7.current,
                start: 'top top',
                end: '90%',
                pin: '#wave1',
                scrub: true,
            }
        }).to(MenuIcons, {
            duration: 2,
            stagger: 1,
            boxShadow: 'var(--iconShadow) black',
            color: 'black',
        }).to ("#logoX", {
            duration: 2,
            color: '#28292B'
        });
    }

    render() {
        return (
            <section ref={scene7} className={"s7-container bg3"}>
                <div id={'scene7'} className='content accessibility-img'>
                    <WaveContainer wid="wave1" fill='#EE303B' speed={0.35} points={5}>
                        <div className={"s7-text-container"}>
                            <h1 className={'s7-text'}>
                                {getSpan(["home_technology_creativity_txt",
                                        "home_technology_creativity_txt_2",
                                        "home_technology_creativity_txt_3"],
                                    's7-txt')}
                            </h1>
                        </div>
                    </WaveContainer>
                </div>
            </section>
        )
    }
}

export default Scene7;
